import moment from 'moment';

/**
 * Períodos del filtro de fechas por rango (el "Fecha de turno" / "Fecha Prometida" de
 * tickets, el "Período" de combustibles, infracciones, reportes...).
 *
 * La lista y la derivación a un rango concreto estaban escritas a mano en cada pantalla.
 * Acá se centralizan con los MISMOS ids que usaba la grilla de tickets, porque esos ids
 * se persisten en localStorage: cambiarlos invalidaría los filtros ya guardados.
 *
 * OJO con los ids, no son días: el 20 es "Últimos 30 días" y el 30 es "Este mes".
 * Son históricos y se conservan tal cual a propósito.
 */

export const PERIODO_TODO = 0;
export const PERIODO_HOY = 1;
export const PERIODO_AYER = 2;
export const PERIODO_ULTIMOS_7 = 7;
export const PERIODO_ULTIMOS_14 = 14;
export const PERIODO_ULTIMOS_30 = 20;
export const PERIODO_ESTE_MES = 30;
export const PERIODO_MES_PASADO = 60;
export const PERIODO_ESTE_ANIO = 365;
export const PERIODO_ANIO_PASADO = 400;

/**
 * El período personalizado. No es una opción más: su fila del desplegable renderiza dos
 * DatePicker y los botones Aplicar/Cancelar, y por eso viene con `label` vacío (el texto
 * lo arma el propio control al aplicar: "Del 01-08-26 al 19-08-26").
 */
export const PERIODO_PERSONALIZADO = 12;

const FORMATO = 'YYYY-MM-DD';

/** Las opciones del desplegable, en el orden en que se venían mostrando. */
export const buildPeriodoOptions = (intl) => [
	{ id: PERIODO_HOY, label: intl.formatMessage({ id: 'Hoy', defaultMessage: 'Hoy' }) },
	{ id: PERIODO_AYER, label: intl.formatMessage({ id: 'Ayer', defaultMessage: 'Ayer' }) },
	{ id: PERIODO_ULTIMOS_7, label: intl.formatMessage({ id: 'Ultimos_7_dias', defaultMessage: 'Últimos 7 días' }) },
	{ id: PERIODO_ULTIMOS_14, label: intl.formatMessage({ id: 'Ultimos_14_dias', defaultMessage: 'Últimos 14 días' }) },
	{ id: PERIODO_ULTIMOS_30, label: intl.formatMessage({ id: 'Ultimos_30_dias', defaultMessage: 'Últimos 30 días' }) },
	{ id: PERIODO_ESTE_MES, label: intl.formatMessage({ id: 'Este_mes', defaultMessage: 'Este mes' }) },
	{ id: PERIODO_MES_PASADO, label: intl.formatMessage({ id: 'Mes_Pasado', defaultMessage: 'Mes Pasado' }) },
	{ id: PERIODO_ESTE_ANIO, label: intl.formatMessage({ id: 'Este_anio', defaultMessage: 'Este año' }) },
	{ id: PERIODO_ANIO_PASADO, label: intl.formatMessage({ id: 'Anio_Pasado', defaultMessage: 'Año Pasado' }) },
	{ id: PERIODO_TODO, label: intl.formatMessage({ id: 'Todo', defaultMessage: 'Todo' }) },
	{ id: PERIODO_PERSONALIZADO, label: '' },
];

/**
 * Rango concreto de un período elegido, en 'YYYY-MM-DD'. Los relativos se calculan CADA
 * VEZ que se serializa y no al elegirlos: así un "Hoy" guardado ayer sigue significando
 * hoy (antes se persistían las fechas ya calculadas y el filtro quedaba viejo).
 *
 * Réplica exacta de la derivación que tenía TicketGridFilters, incluido el default del
 * switch (cualquier id no listado cae en "este año").
 */
export const rangoDePeriodo = (option) => {
	if (!option) return { inicio: '', fin: '' };

	if (option.id === PERIODO_PERSONALIZADO) {
		if (!option.inicio) return { inicio: '', fin: '' };
		return { inicio: moment(option.inicio).format(FORMATO), fin: moment(option.fin).format(FORMATO) };
	}

	switch (option.id) {
		case PERIODO_TODO:
			return { inicio: '', fin: '' };
		case PERIODO_HOY:
			return { inicio: moment().format(FORMATO), fin: moment().format(FORMATO) };
		case PERIODO_AYER:
			return {
				inicio: moment().subtract(1, 'days').format(FORMATO),
				fin: moment().subtract(1, 'days').format(FORMATO),
			};
		case PERIODO_ULTIMOS_7:
			return { inicio: moment().subtract(7, 'days').format(FORMATO), fin: moment().format(FORMATO) };
		case PERIODO_ULTIMOS_14:
			return { inicio: moment().subtract(14, 'days').format(FORMATO), fin: moment().format(FORMATO) };
		case PERIODO_ULTIMOS_30:
			return { inicio: moment().subtract(30, 'days').format(FORMATO), fin: moment().format(FORMATO) };
		case PERIODO_ESTE_MES:
			return { inicio: moment().startOf('month').format(FORMATO), fin: moment().format(FORMATO) };
		case PERIODO_MES_PASADO:
			return {
				inicio: moment().subtract(1, 'months').startOf('month').format(FORMATO),
				fin: moment().subtract(1, 'months').endOf('month').format(FORMATO),
			};
		case PERIODO_ANIO_PASADO:
			return {
				inicio: moment().subtract(1, 'year').startOf('year').format(FORMATO),
				fin: moment().subtract(1, 'year').endOf('year').format(FORMATO),
			};
		default:
			return { inicio: moment().startOf('year').format(FORMATO), fin: moment().format(FORMATO) };
	}
};
